import { Suspense } from 'react';

import { RouteWrapper } from './routes';

export const App = () => {
    return (
        <Suspense>
            <RouteWrapper />
        </Suspense>
    );
};
